import { Input, ElementRef, Directive } from "@angular/core";
import { FormControlData } from "../base-models/form-control-data";
import { BaseDataService } from "../base-services/base-data.service";
import { QueryParameter } from "../base-models/query-parameter";

@Directive({
    selector: '[isVisible]'
})
export class IsVisibleDirective {

    constructor(private el: ElementRef, private baseDataService: BaseDataService){

    }

    @Input('isVisible') ControlID: string;
    @Input() Url: string;
    ControlValues: FormControlData[];
    @Input() PodvrstaDokumentaID: number;
    @Input() PodvrstaDokumentStavkaID: number

    ngOnInit(){
        //this.baseDataService.Get('formControl', 'getByUrl', [new QueryParameter('url', this.Url)], FormControlData)
            //.subscribe(data => {
                //this.ControlValues = data;
                //let control = this.ControlValues.find(value => value.ControlID == this.ControlID);
                //if(control)
                    //this.el.nativeElement.style.display = control.IsVisible ? "block" : "none";
            //})
    }
}